import { callUIAPI, isSuccessCode } from './apiUtils';
import { METHOD_POST, METHOD_DELETE, METHOD_PUT, METHOD_GET, SERVER_URL } from './apiUtilsConstants';

export const getSEOGuidelines = async (input) => {
  console.log('apiUtils.getSEOGuidelines - input:', input);

  return callUIAPI('seo/guidelines', input ?? {}, METHOD_POST, true)
  .then(response => {
    console.log('apiUtils.getSEOGuidelines - response:', response)
    return response;
  })
};

export const getSEOSuggestions = async (contentId) => {
  console.log('apiUtils.getSEOSuggestions - contentId:', contentId);
  
  if (!contentId) {
    return { success: true, list: [] };
  }

  try {
    const response = await callUIAPI(`contents/${contentId}/seo-suggestions`, {}, METHOD_GET, true);
    if (!isSuccessCode(response.status)) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    // The backend returns { list: [...] }
    return {
      success: true,
      suggestions: response.data.list || []
    };
  } catch (error) {
    console.error('apiUtils.getSEOSuggestions - Error:', error);
    throw error;
  }
};

export const saveSEOSuggestionStatus = async (contentId, seoSuggestionId, status) => {
  console.log('apiUtils.saveSEOSuggestionStatus - contentId:', contentId, 'seoSuggestionId:', seoSuggestionId, 'status:', status);

  const payload = {
    seoSuggestionId,
    status
  };

  try {
    const response = await callUIAPI(`contents/${contentId}/seo-suggestion`, payload, METHOD_PUT, true);
    if (!isSuccessCode(response.status)) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.data;
  } catch (error) {
    console.error('apiUtils.saveSEOSuggestionStatus - error:', error);
    throw error;
  }
};


export const getContentMedia = async (contentId, platform) => {
  console.log('contentApiUtils.getContentMedia - contentId:', contentId, 'platform:', platform);

  if (!contentId || !platform) {
    return { success: true, list: [] };
  }

  try {
    const response = await callUIAPI(
      `contents/${contentId}/media`,
      { platform },
      METHOD_GET,
      true
    );
    if (!isSuccessCode(response.status)) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return {
      success: true,
      list: response.data.list || [],
    };
  } catch (error) {
    console.error('contentApiUtils.getContentMedia - error:', error);
    throw error;
  }
};

export const saveContentMedia = async (contentId, platform, items) => {
  console.log(
    'contentApiUtils.saveContentMedia - contentId:',
    contentId,
    'platform:',
    platform,
    'items:',
    items
  );

  if (!contentId || !platform) {
    throw new Error('contentId and platform are required to save media.');
  }

  try {
    const response = await callUIAPI(
      `contents/${contentId}/media`,
      { platform, items: items || [] },
      METHOD_PUT,
      true
    );
    if (!isSuccessCode(response.status)) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.data;
  } catch (error) {
    console.error('contentApiUtils.saveContentMedia - error:', error);
    throw error;
  }
};


export const deleteGeneratedContent = async (contentId, generatedContentId) => {
  try {
    const response = await callUIAPI(
      `contents/${contentId}/generated/${generatedContentId}`,
      null,
      METHOD_DELETE,
      true,
    );
    if (!isSuccessCode(response.status)) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.data;
  } catch (error) {
    console.error('contentApiUtils.deleteGeneratedContent - error:', error);
    throw error;
  }
};


export const getContentUsageStats = async () => {
  console.log('contentApiUtils.getContentUsageStats');
  try {
    const response = await callUIAPI('contents/usage', {}, METHOD_GET, true);
    if (!isSuccessCode(response.status)) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.data;
  } catch (error) {
    console.error('contentApiUtils.getContentUsageStats - error:', error);
    // Return a safe default to prevent UI crashes, effectively assuming unlimited or handling gracefully
    return { used: 0, limit: -1, isUnlimited: true }; 
  }
};

export const getAIPrompts = async (entityName, id, requestBody) => {
  console.log('apiUtils.getAIPrompts - entityName:', entityName, ', id:', id, ', requestBody:', requestBody);

  try {
    return callUIAPI(`generatecontent/aiprompt/${entityName}/${id}`, requestBody ?? {}, METHOD_POST, true)
    .then(response => {
      console.log('apiUtils.getAIPrompts - response:', response)
      if (!isSuccessCode(response.status)) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.data.aiPrompts;
    });
  }
  catch (error) {
    console.error('apiUtils.getAIPrompts - error:', error);
    throw error;
  }
};

export const generateContent = async (input, signal) => {
  console.log('apiUtils.generateContent - input:', input);

  try {
    return fetch(`${SERVER_URL}/api/ui/generatecontent`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(input),
      credentials: 'include',
      signal
    });
  }
  catch (error) {
    console.error('apiUtils.generateContent - error:', error);
    throw error;
  }
};

export const stopContentGeneration = async (generationId) => {
  console.log('apiUtils.stopGeneration - generationId:', generationId);

  try {
    const response = await callUIAPI(`stopcontentgeneration/${generationId}`, undefined, METHOD_DELETE, true);

    if (!isSuccessCode(response.status)) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.data.message;
  }
  catch (error) {
    console.error('apiUtils.stopGeneration - error:', error);
    throw error;
  }
};

export const voteForContentType = async (contentTypeId) => {
  console.log('contentApiUtils.voteForContentType - contentTypeId:', contentTypeId);

  try {
    const response = await callUIAPI('votes/vote', { contentTypeId }, METHOD_POST, true);

    if (!isSuccessCode(response.status)) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.data;
  } catch (error) {
    console.error('contentApiUtils.voteForContentType - error:', error);
    throw error;
  }
};

export const getContentTypeVoteStatuses = async () => {
  console.log('contentApiUtils.getContentTypeVoteStatuses');

  try {
    const response = await callUIAPI('votes/statuses', {}, METHOD_GET, true);

    if (!isSuccessCode(response.status)) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.data;
  } catch (error) {
    console.error('contentApiUtils.getContentTypeVoteStatuses - error:', error);
    throw error;
  }
};


export const getMetadataGuidelines = async (contentTypeName, parentContentTypeName) => {
  console.log('contentApiUtils.getMetadataGuidelines - contentTypeName:', contentTypeName, ', parentContentTypeName:', parentContentTypeName);
  const MetadataGuidelinesDAO = (await import('../dao/MetadataGuidelinesDAO')).default;
  try {
    const metadata = await MetadataGuidelinesDAO.getMetadataGuidelines(contentTypeName, parentContentTypeName);
    console.log('contentApiUtils.getMetadataGuidelines - metadata:', metadata);
    return { success: true, metadata };
  } catch (error) {
    console.error('contentApiUtils.getMetadataGuidelines - Error:', error);
    throw error;
  }
};

export const getContentValidators = async (input = {}) => {
  console.log('contentApiUtils.getContentValidators - input:', input);
  try {
    const response = await callUIAPI('content-validators', input, METHOD_GET, true);
    if (!isSuccessCode(response.status)) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    // Controller returns { validators: [...] }
    return response.data;
  } catch (error) {
    console.error('contentApiUtils.getContentValidators - error:', error);
    throw error;
  }
};

export const validateContent = async (input) => {
  console.log('contentApiUtils.validateContent - input:', { ...input, content: '…' });
  try {
    const response = await callUIAPI('content-validators/validate', input, METHOD_POST, true);
    if (!isSuccessCode(response.status)) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    // Controller returns { overallVerdict, results, validatedAt }
    return response.data;
  } catch (error) {
    console.error('contentApiUtils.validateContent - error:', error);
    throw error;
  }
};